import { ReportTypes } from '@mode/shared/contract-common';
import {
  TableListAvatarValue,
  TableListHtmlValue,
  TableListIconValue,
  TableListTextValue,
  TableListValueType,
  TableListBadgeWithTextValue,
} from './table-list-value';

export const avatarValue = (
  data: TableListAvatarValue['data'] = { avatar: null, size: null },
  type: TableListValueType.Avatar = TableListValueType.Avatar
): TableListAvatarValue => ({ type, data });

export const htmlValue = (
  data: TableListHtmlValue['data'] = '',
  type: TableListValueType.Html = TableListValueType.Html
): TableListHtmlValue => ({ type, data });

export const textValue = (
  data: TableListTextValue['data'] = '',
  type: TableListValueType.Text = TableListValueType.Text
): TableListTextValue => ({ type, data });

export const iconValue = (
  data: TableListIconValue['data'] = ReportTypes.ReportType.Report,
  type: TableListValueType.Icon = TableListValueType.Icon
): TableListIconValue => ({ type, data });

export const badgeWithTextValue = (
  data: TableListBadgeWithTextValue['data'] = '',
  type: TableListValueType.BadgeWithText = TableListValueType.BadgeWithText
): TableListBadgeWithTextValue => ({ type, data });

export const getValue = (data: any, type = TableListValueType.Text) => {
  const methods = {
    [TableListValueType.Avatar]: (valueData: TableListAvatarValue['data']) => avatarValue(valueData),
    [TableListValueType.Text]: (valueData: TableListTextValue['data']) => textValue(valueData),
    [TableListValueType.Html]: (valueData: TableListHtmlValue['data']) => htmlValue(valueData),
    [TableListValueType.Icon]: (valueData: TableListIconValue['data']) => iconValue(valueData),
    [TableListValueType.BadgeWithText]: (valueData: TableListBadgeWithTextValue['data']) =>
      badgeWithTextValue(valueData),
  };

  return methods[type](data);
};
